import "@/assets/scss/mains.scss";

//
import axios from "axios";

window.axios = axios;

//
import $ from "jquery";

window.$ = window.jQuery = $;


//
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


Vue.prototype.window = window;
Vue.prototype.$application = window.$application;

Vue.prototype.$eventbus = window.$eventbus = new Vue({});

window.$application.helpers = {
    getLinkAndValues(url, path, values) {

        const _url = new URL(url);
        const _url_origin = _url.origin;
        const _url_pathname = _url.pathname;

        const _path = new URL(_url_origin + _url_pathname + path);

        for (let key in values) {
            _path.searchParams.append(key, values[key]);
        }

        return _path.href.replace(_url_origin + _url_pathname, '');

    }
}


//
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//     id: $application.config.analytics.id,
//     router: router,
//     autoTracking: {
//         skipSamePath: true,
//         pageviewTemplate(route) {
//             return {
//                 page: '/' + $application.config.analytics.page_var + route.path,
//                 title: document.title,
//                 location: window.location.href
//             }
//         }
//     },
//     debug: {
//         enabled: $application.config.analytics.debug,
//         sendHitTask: $application.config.analytics.enabled
//     }
// });

window.getPDCVersion = function() {
    
    return "vers_a";
    
    if (version) {
        return version;
    } else {
        version = Math.floor(Math.random() * 100);
        if (version % 2 == 0) {
            version = "vers_b";
        } else {
            version = "vers_a";
        }
        localStorage.setItem("ab_group", version);
    }
    return version;
};

//analitycs
function gtag() {
    dataLayer.push(arguments);
}
window.dataLayer = window.dataLayer || []; 
window.gtag = gtag;
if (window.gtag) {
    gtag('set', 'user_properties', {
        'PDC_version': window.getPDCVersion()
    });
}
//add dimensions
var tracking_dimensions = {};
    tracking_dimensions["PDC_version"] = window.getPDCVersion();
if (window.dataLayer) {
    window.dataLayer.push(tracking_dimensions);
}
//import script
import  "./analytics.js";
Vue.prototype.$gtag = window.gtag;




Vue.mixin({

    computed:{
        isLoggedIn: function () {
            var api_token = this.$store.state.api_token;
            var persist_login = this.$store.state.persist_login;

            return api_token !== 'null' && api_token !== null && api_token !== '';
            // return !!api_token;
        }
    },

    methods: {
        // ga(page, title) {
        //     this.$ga.page({
        //         page:  "/" +  $application.config.analytics.page_var + "/" +  page,
        //         title: title
        //     });
        // },
        getPDCVersion: window.getPDCVersion,
        trackEvent(eventName, eventValues) {
            for (var i in tracking_dimensions) {
                if (typeof eventValues[i] == "undefined") {
                    eventValues[i] = tracking_dimensions[i];
                }
            }

            console.log("trackEvent eventName="+eventName+" eventValues=", eventValues);
            if (window.gtag) {
                window.gtag('event', eventName, eventValues);
            } else {
                if (eventValues.event_callback) {
                    eventValues.event_callback();
                }
                if (eventValues.eventCallback) {
                    eventValues.eventCallback();
                }
            }
        },
        ga(page, title) { 
            this.$gtag('event', 'click', {
                'event_category': page,
                'event_label': title
            });
        }, 
    }
})



Vue.config.productionTip = false

database(()=>{
    new Vue({
        router,
        store,
        render: function (h) {
            return h(App)
        }
    }).$mount('#app')
});
